export default function OrderSuccess() {

  return (
    <div className="success-page">
      <h1>✅ Order Placed Successfully</h1>
      <p>Thank you for your order.</p>
      <p>Your order has been received successfully.</p>
    </div>
  );
}